(function(){
    'use strict';

    var $formFilter = $('.smp-a-z-forms__filter input'),
        $formList = $('.smp-a-z-forms__list > ul li');
    
    $formFilter.keyup(function(){
        var searchText = $(this).val().toLowerCase();

        $formList.each(function(){
            var currentText = $(this).text().toLowerCase(),
                showCurrentText = currentText.indexOf(searchText) !== -1;
            $(this).toggle(showCurrentText);
        });     
    });
    
}());
